import { create } from "zustand";
import { PointCloudStatsMap } from "./point-cloud-stats-collector";
import { PointOpacityMap } from "./point-opacity-collector";

export type RenderingStatsContext = {
  /** Map from point cloud ID to the stats for that point cloud. */
  pointCloudStatsMap: PointCloudStatsMap;
  /** Update the stats for each point cloud. */
  setPointCloudStatsMap(pointCloudStats: PointCloudStatsMap): void;
  /** Map from point cloud ID to the opacity stats for that point cloud. */
  pointOpacityMap: PointOpacityMap;
  /** Update the opacity stats for each point cloud. */
  setPointOpacityMap(pointOpacityMap: PointOpacityMap): void;
};

/** Context containing data and stats related to rendering, for debug purposes. */
export const useRenderingStatsContext = create<RenderingStatsContext>(
  (set) => ({
    pointCloudStatsMap: {},
    setPointCloudStatsMap: (pointCloudStats: PointCloudStatsMap) =>
      set({ pointCloudStatsMap: pointCloudStats }),
    pointOpacityMap: {},
    setPointOpacityMap: (pointOpacityMap: PointOpacityMap) =>
      set({ pointOpacityMap }),
  }),
);
